import { createContext } from 'react'
import { TourPlanningStore } from './tourPlanningStoreTypes'

export const TourPlanningContext = createContext<TourPlanningStore | null>(null)
